document.addEventListener('livewire:init', function () {
	window.App = window.App || {};

	Livewire.on('updateMenus', () => {
		setTimeout(() => {
			window.KTMenu?.createInstances?.();
		}, 250);
	});

	if (window.App.tasksManagerMenuMorphHookRegistered) {
		return;
	}

	window.App.tasksManagerMenuMorphHookRegistered = true;
	let tasksManagerMenuTimer = null;

	Livewire.hook('morph.updated', ({ el }) => {
		const containsTasksManager = el?.matches?.('.tasks-manager')
			|| el?.closest?.('.tasks-manager')
			|| el?.querySelector?.('.tasks-manager');

		if (!containsTasksManager) {
			return;
		}

		window.clearTimeout(tasksManagerMenuTimer);
		tasksManagerMenuTimer = window.setTimeout(() => {
			window.KTMenu?.createInstances?.('.tasks-manager [data-kt-menu="true"]');
		}, 0);
	});
});